import { getLocale as getLocaleFromLs, storeLocale } from '@/shared/helpers/local-storage.js';
import {i18n} from "@/app/locale.js";
export const DEFAULT_LOCALE = "en";

const allowedLocales = ['en', 'ru', 'es', 'ua'];

export const getLocale = () => {
    let locale = getLocaleFromLs();

    if (!locale) {
        locale = navigator.language.split('-')[0] ?? DEFAULT_LOCALE;
    }

    if (allowedLocales.indexOf(locale) < 0) {
        locale = DEFAULT_LOCALE;
    }

    return locale;
}

export const setLocale = (locale) => {
    storeLocale(locale);
}


export const getLocalizedValueTranslation = (translations, field, locale) => {
    if (!locale) {
        locale = i18n.global.locale.value;
    }

    let currentLocaleTranslations = translations.find(translation => translation.locale === locale);
    if (!currentLocaleTranslations) {
        for (const allowedLocale of allowedLocales) {
            currentLocaleTranslations = translations.find(translation => translation.locale === allowedLocale);
            if (currentLocaleTranslations) {
                break;
            }
        }
    }

    if (!currentLocaleTranslations) {
        return null;
    }

    return currentLocaleTranslations[field] ?? null;
}

export const getLocalizedFieldValue = (item, field, locale = null) => {
    if (!locale) {
        locale = i18n.global.locale.value;
    }

    if (item.translations) {
        const translatedValue = getLocalizedValueTranslation(item.translations, field, locale);
        if (translatedValue !== null) {
            return translatedValue;
        }
        return item[field];
    }

    const localeFieldName = `${field}_${locale}`;

    let result = item[localeFieldName] ?? item[field];

    if (!result) {
        for (const allowedLocale of allowedLocales) {
            const fieldName = `${field}_${allowedLocale}`;
            if (item[fieldName]) {
                result = item[fieldName];
                break;
            }
        }
    }

    return result || '';
}

export const getLocalizedValueFromObject = (item, locale = null) => {
    if (typeof item !== 'object') {
        return item;
    }

    if (!locale) {
        locale = i18n.global.locale.value;
    }

    if (item[locale]) {
        return item[locale];
    }

    if (item["en"]) {
        return item["en"];
    }

    return Object.values(item)?.[0] ?? '';
}
